---
title: 'Step 3: Verify Configuration'
install_track_title: Installation Guide (Heroku Postgres)
backlink_href: /docs/install
backlink_title: 'Installation Guide'
---

import PublicLastStepLogInsightsLink from '../_public_last_step_log_insights_link.mdx'

import { collectorAppName, attachmentName } from "./util";

export const HerokuConfigCommand = ({ organizationSlug }) => {
  return (
    <CodeBlock>{`heroku config -a ${collectorAppName(organizationSlug)}`}</CodeBlock>
  );
};

export const HerokuConfigOutput = ({ organizationSlug }) => {
  return (
    <CodeBlock>
      {`=== ${collectorAppName(organizationSlug)} Config Vars
${attachmentName(organizationSlug)}_URL: postgres://...:...@...:.../...
PGA_API_KEY: ...`}
    </CodeBlock>
  );
};

export const TestCommand = ({ organizationSlug }) => {
  return (
    <CodeBlock>{`heroku run -a ${collectorAppName(organizationSlug)} -- collector --test`}</CodeBlock>
  );
};

export const TestOutput = ({ organizationSlug }) => {
  const attUrl = attachmentName(organizationSlug) + "_URL";
  return (
    <CodeBlock>
      {`Running collector --test on ⬢ ${collectorAppName(
        organizationSlug
      )}... up, run.7708
2024/09/23 08:58:49 I Running collector test with pganalyze-collector 0.58.0
2024/09/23 08:58:49 I [DATABASE_URL] Testing statistics collection...
2024/09/23 08:58:50 I [DATABASE_URL]   Test collection successful for PostgreSQL 16.2 on aarch64-unknown-linux-gnu, compiled by aarch64-unknown-linux-gnu-gcc (GCC) 9.5.0, 64-bit
2024/09/23 08:58:50 I [DATABASE_URL]   Test snapshot successful
2024/09/23 08:58:50 I [DATABASE_URL] Testing activity snapshots...
2024/09/23 08:58:50 I [DATABASE_URL]   Test snapshot successful
...`}
    </CodeBlock>
  );
};

You can verify that your database has been attached by checking the `heroku config` of the collector application:

<HerokuConfigCommand organizationSlug={props.organizationSlug} />

This will output something like the following:

<HerokuConfigOutput organizationSlug={props.organizationSlug} />

Now, you can verify the configuration by running the test command:

<TestCommand organizationSlug={props.organizationSlug} />

This should output something similar to the following:

<TestOutput organizationSlug={props.organizationSlug} />

<PublicLastStepLogInsightsLink />
